//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets a tenant the user is member of
 */
export function getTenant(config?: AxiosRequestConfig | undefined): Promise<Types.TenantDto> {
    let url_ = getBaseUrl() + "/api/tenants";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetTenant,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetTenant?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetTenant(_response);
    });
}

function processGetTenant(response: AxiosResponse): Promise<Types.TenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initTenantDto(resultData200);
        return Promise.resolve<Types.TenantDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TenantDto>(null as any);
}

/**
 * Creates new Tenant
 */
export function createTenant(createTenantDto: Types.CreateTenantDto, config?: AxiosRequestConfig | undefined): Promise<Types.TenantDto> {
    let url_ = getBaseUrl() + "/api/tenants";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createTenantDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateTenant,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateTenant?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateTenant(_response);
    });
}

function processCreateTenant(response: AxiosResponse): Promise<Types.TenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initTenantDto(resultData200);
        return Promise.resolve<Types.TenantDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initTenantDto(resultData201);
        return Promise.resolve<Types.TenantDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TenantDto>(null as any);
}

/**
 * Creates new Subtenant within current Tenant
 */
export function createSubtenant(createSubtenantDto: Types.CreateSubtenantDto, config?: AxiosRequestConfig | undefined): Promise<Types.SubtenantDto> {
    let url_ = getBaseUrl() + "/api/tenants/subtenants";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateSubtenantDto(createSubtenantDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateSubtenant,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateSubtenant?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateSubtenant(_response);
    });
}

function processCreateSubtenant(response: AxiosResponse): Promise<Types.SubtenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSubtenantDto(resultData200);
        return Promise.resolve<Types.SubtenantDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initSubtenantDto(resultData201);
        return Promise.resolve<Types.SubtenantDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SubtenantDto>(null as any);
}

/**
 * Returns all Subtenants within current Tenant
 * @param subtenantIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getSubtenants(subtenantIds?: number[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfSubtenantDto> {
    let url_ = getBaseUrl() + "/api/tenants/subtenants?";
    if (subtenantIds !== undefined && subtenantIds !== null)
        subtenantIds && subtenantIds.forEach(item => { url_ += "SubtenantIds=" + encodeURIComponent("" + item) + "&"; });
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSubtenants,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetSubtenants?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSubtenants(_response);
    });
}

function processGetSubtenants(response: AxiosResponse): Promise<Types.PageableListDtoOfSubtenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfSubtenantDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfSubtenantDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfSubtenantDto>(null as any);
}

export function patchSubtenant(subtenantId: number, patchSubtenantDto: Types.PatchSubtenantDto, config?: AxiosRequestConfig | undefined): Promise<Types.SubtenantDto> {
    let url_ = getBaseUrl() + "/api/tenants/subtenants/{subtenantId}";
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchSubtenantDto(patchSubtenantDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchSubtenant,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchSubtenant?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchSubtenant(_response);
    });
}

function processPatchSubtenant(response: AxiosResponse): Promise<Types.SubtenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSubtenantDto(resultData200);
        return Promise.resolve<Types.SubtenantDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SubtenantDto>(null as any);
}
let _requestConfigGetTenant: Partial<AxiosRequestConfig> | null;
export function getGetTenantRequestConfig() {
  return _requestConfigGetTenant;
}
export function setGetTenantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetTenant = value;
}
export function patchGetTenantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetTenant = patch(_requestConfigGetTenant ?? {});
}

let _requestConfigCreateTenant: Partial<AxiosRequestConfig> | null;
export function getCreateTenantRequestConfig() {
  return _requestConfigCreateTenant;
}
export function setCreateTenantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateTenant = value;
}
export function patchCreateTenantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateTenant = patch(_requestConfigCreateTenant ?? {});
}

let _requestConfigCreateSubtenant: Partial<AxiosRequestConfig> | null;
export function getCreateSubtenantRequestConfig() {
  return _requestConfigCreateSubtenant;
}
export function setCreateSubtenantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateSubtenant = value;
}
export function patchCreateSubtenantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateSubtenant = patch(_requestConfigCreateSubtenant ?? {});
}

let _requestConfigGetSubtenants: Partial<AxiosRequestConfig> | null;
export function getGetSubtenantsRequestConfig() {
  return _requestConfigGetSubtenants;
}
export function setGetSubtenantsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSubtenants = value;
}
export function patchGetSubtenantsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSubtenants = patch(_requestConfigGetSubtenants ?? {});
}

let _requestConfigPatchSubtenant: Partial<AxiosRequestConfig> | null;
export function getPatchSubtenantRequestConfig() {
  return _requestConfigPatchSubtenant;
}
export function setPatchSubtenantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchSubtenant = value;
}
export function patchPatchSubtenantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchSubtenant = patch(_requestConfigPatchSubtenant ?? {});
}